<div
  class="border rounded bg-white"
  [class.p-0]="viewAsSource"
  [class.p-3]="!viewAsSource"
  [class.viewer-source]="viewAsSource"
>
  <div *ngIf="!viewAsSource" #contentHost (click)="onHostClick($event)">
    <div [innerHTML]="toBodyHtml(itemHtml)"></div>
  </div>
  
  <div *ngIf="viewAsSource" class="mb-0">
    <div class="row h-100 flex-grow-1">
      <div class="col-12 d-flex flex-column h-100">
        <ngx-codemirror
          class="codemirror-fullscreen flex-grow-1"
          [(ngModel)]="itemHtml"
          [options]="codemirrorOptions"
          [ngModelOptions]="{ standalone: true }"
        >
        </ngx-codemirror>
      </div>
    </div>
  </div>
</div>
